var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('NavBar'),_c('b-container',{staticClass:"nav-padding"},[_c('b-row',[_c('b-col',{staticClass:"text-center"},[_c('b-spinner',{attrs:{"variant":"light"}})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }